$(function(){
    refresh_live_wc();
    setInterval(refresh_live_wc, 60000);
    setInterval(refresh_live_standing_wc, 60000);

    $( ".league_menu" ).first().clone().removeClass("hidden-xs hidden-sm").removeClass("league_menu").addClass("league_menu_xs").appendTo( ".menu_xs_wrapper" );

    if($("#wc_live_today").length){

        $.get(
            ajaxUrl+"/ajax/getWcLivescore.php",
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $(".live_fixtures").html(result.live);
                    $(".later_fixtures").html(result.later);
                    $("#live_today_loader").fadeOut(function(){
                        $(".fixtures_today").fadeIn();
                    });
                    $(".wc-live-spinner").delay(5000).fadeOut();
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                    loadOdds();
                    checkNotificationCheckboxes();
                }
            }
        );
    }

    if($("#vm-spelschema").length){
        $.get(
            ajaxUrl+"/ajax/getVmSpelschema.php",
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#groupstage").html(result.groupstage);
                    $("#playoff").html(result.playoff);
                    //$(".wc-live-spinner").delay(5000).fadeOut();
                    loadOdds();
                    checkNotificationCheckboxes();
                }
            }
        )
    }

    if($("#vm-tip").length){
        $.get(
            ajaxUrl+"/ajax/getVmTip.php",
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#vm-tip-content").html(result.tips);
                }
            }
        )
    }

    $(document).on("click", ".vm-menu-xs", function(){
        $(".menu_xs_wrapper").slideToggle("fast", function(){
            if($(this).is(":visible")){
                $(".tab-content").addClass("blur");
            } else {
                $(".tab-content").removeClass("blur");
            }
        });
        return false;
    });
    $(document).on("click", ".menu_xs_wrapper .league_menu_xs a", function(){
        $(".vm-menu-xs").click();
    });
    $(document).on("click", ".btn-shirts", function(){
        $(".league_menu > li").removeClass("active");
        $('div#shirts').addClass("active");
        $("#vm_tabs > .tab-pane").each(function(){
            if($(this).attr("id") != "shirts"){
                $(this).removeClass("active");
            }
        });
        return false;
    });
    $(".bet_swipe").bind('oanimationend animationend webkitAnimationEnd', function() {
        $(this).fadeOut();
    });

    if($("#wc_kickoff_time").length){
        var deadline = new Date("June 16, 2018 17:00:00");
        initializeClock('clockdiv', deadline);
    }
    $(".bet_select").change(function(){
        var target = $(this).find(':selected').data('event');
        $(".bet-tabs .tab-pane").removeClass("active");
        $("#"+target).addClass("active");
        return false;
    });

});

function getTimeRemaining(endtime) {
    var t = Date.parse(endtime) - Date.parse(new Date());
    var seconds = Math.floor((t / 1000) % 60);
    var minutes = Math.floor((t / 1000 / 60) % 60);
    var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
    var days = Math.floor(t / (1000 * 60 * 60 * 24));
    return {
        'total': t,
        'days': (days-2),
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
    };
}

function initializeClock(id, endtime) {
    var clock = document.getElementById(id);
    var daysSpan = clock.querySelector('.days'); 
    var hoursSpan = clock.querySelector('.hours');
    var minutesSpan = clock.querySelector('.minutes');
    var secondsSpan = clock.querySelector('.seconds');

    function updateClock() {
        var t = getTimeRemaining(endtime);

        daysSpan.innerHTML = '0' + t.days;
        hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
        minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
        secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

        if (t.total <= 0) {
            clearInterval(timeinterval);
        }
    }

    updateClock();
    $("#clockdiv").fadeIn();
    var timeinterval = setInterval(updateClock, 1000);
}

function refresh_live_wc() {
    // Only proceed if we have games playing.
    if($(".wc-live-spinner").length){
        $(".wc-live-spinner").fadeIn("fast");
        $.get(
            ajaxUrl+"/ajax/getWcLivescore.php",
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $(".live_fixtures").html(result.live);
                    $(".later_fixtures").html(result.later);
                    $(".wc-live-spinner").delay(5000).fadeOut();
                    $('img[data-src]').each(function(img){
                        $(this).attr('src', $(this).data('src'));
                        $(this).removeAttr('data-src');
                    });
                    loadOdds();
                    checkNotificationCheckboxes();
                }
            }
        );
    }
}

function refresh_live_standing_wc(){
    if($("#wc_group_live").length){
        $.get(
            ajaxUrl+"/ajax/getWcStandings.php",
            {
                group_id : $("#wc_group_live").val()
            },
            function(data){
                var result = $.parseJSON(data);
                if(result.success == true){
                    $("#standing-"+$("#wc_group_live").val()+" > tbody").replaceWith(result.html);
                }
            }
        );
    }
}